import { useEffect } from "react";
import Animated, {
	useAnimatedStyle,
	withRepeat,
	withSequence,
	withTiming,
	useSharedValue,
} from "react-native-reanimated";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	radius: number;
	innerRadius: number;
	children?: React.ReactNode;
};

const SkeletonDonutChart = ({ radius, innerRadius, children }: Props) => {
	const theme = useAppTheme();
	const opacity = useSharedValue(0.3);

	useEffect(() => {
		opacity.value = withRepeat(
			withSequence(
				withTiming(1, { duration: 800 }),
				withTiming(0.3, { duration: 800 }),
			),
			-1,
		);
	}, [opacity]);

	const animatedStyle = useAnimatedStyle(() => ({
		opacity: opacity.value,
	}));

	const ringWidth = radius - innerRadius;

	return (
		<Box
			alignItems="center"
			justifyContent="center"
			width={radius * 2}
			height={radius * 2}
		>
			<Animated.View
				style={[
					{
						width: radius * 2,
						height: radius * 2,
						borderWidth: ringWidth,
						borderColor: theme.colors.surfaceVariant,
						borderRadius: radius,
						backgroundColor: "transparent",
					},
					animatedStyle,
				]}
			/>
			<Box
				position="absolute"
				height="100%"
				width="100%"
				alignItems="center"
				justifyContent="center"
			>
				{children}
			</Box>
		</Box>
	);
};

export default SkeletonDonutChart;
